import * as stylex from "@stylexjs/stylex";
import {
  breakpoints,
  fonts,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import { useState } from "react";

export function OnePagerLogo({
  logo,
  monogram,
}: {
  readonly logo: string | null;
  readonly monogram: string;
}) {
  const [failedLogo, setFailedLogo] = useState<string | null>(null);
  return (
    <div {...stylex.props(styles.logoSlot)}>
      {logo !== null && failedLogo !== logo ? (
        <img
          {...stylex.props(styles.logo)}
          src={logo}
          alt=""
          onError={() => setFailedLogo(logo)}
        />
      ) : (
        <span
          {...stylex.props(styles.logo, styles.monogram)}
          aria-hidden="true"
        >
          {monogram}
        </span>
      )}
    </div>
  );
}

const styles = stylex.create({
  logoSlot: {
    position: "relative",
    flex: "none",
    alignSelf: { default: "flex-end", [breakpoints.playCompact]: "flex-start" },
    width: {
      default: "min(var(--hero-text-height, 112px), 30cqw)",
      [breakpoints.playCompact]: 64,
    },
    aspectRatio: "1",
  },
  logo: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    borderRadius: { default: 22, [breakpoints.playCompact]: 14 },
    objectFit: "contain",
    backgroundColor:
      "color-mix(in srgb, var(--softmax-color-play-paper) 12%, transparent)",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor:
      "color-mix(in srgb, var(--softmax-color-play-paper) 28%, transparent)",
    padding: spacing.space10,
    boxSizing: "border-box",
  },
  monogram: {
    display: "grid",
    placeItems: "center",
    fontFamily: fonts.mono,
    fontSize: { default: 40, [breakpoints.playCompact]: fontSizes.section },
    fontWeight: 600,
    backgroundColor: "var(--accent)",
  },
});
